<template>
	<div class="test">
		<span>{{value}}</span>
		<button @click="click">CLICK</button>
		<p>
			{{newTest}}
		</p>
	</div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			value: 1223
		};
	},
	props: {
		newtest: Number
	},
	computed: {
		...mapGetters(["getHiddenParameters"]),
		newTest() {
			return this.newtest;
		}
	},
	methods: {
		click() {
			this.value++;
			console.log(this.value);
			this.$emit("testtest", this.value);
		}
	}
};
</script>
{"licenseId":"1337",
"licenseeName":"Artem1488",
"assigneeName":"Artem1488",
"assigneeEmail":"gang@gmail.com",
"licenseRestriction":"Unlimited license till the end of the century.",
"checkConcurrentUse":false,
"products":[
{"code":"II","paidUpTo":"2099-12-31"},
{"code":"DM","paidUpTo":"2099-12-31"},
{"code":"AC","paidUpTo":"2099-12-31"},
{"code":"RS0","paidUpTo":"2099-12-31"},
{"code":"WS","paidUpTo":"2099-12-31"},
{"code":"DPN","paidUpTo":"2099-12-31"},
{"code":"RC","paidUpTo":"2099-12-31"},
{"code":"PS","paidUpTo":"2099-12-31"},
{"code":"DC","paidUpTo":"2099-12-31"},
{"code":"RM","paidUpTo":"2099-12-31"},
{"code":"CL","paidUpTo":"2099-12-31"},
{"code":"PC","paidUpTo":"2099-12-31"},
{"code":"DB","paidUpTo":"2099-12-31"},
{"code":"GO","paidUpTo":"2099-12-31"},
{"code":"RD","paidUpTo":"2099-12-31"}
],
"hash":"2911276/0",
"gracePeriodDays":7,
"autoProlongated":false}
<style lang="scss" scoped>
.test {
	background-color: rgb(129, 102, 102);
	border: 1px solid #000;
	border-radius: 5px;
	width: 100%;
	height: 20vh;
	span {
		width: 10rem;
		background-color: #fff;
		border-radius: 5%;
		padding: 0 1rem;
		margin: 0.5rem;
	}
	button {
		cursor: pointer;
		outline: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/test.vue